import { SvgIcon } from "@mui/material";
import { IconProps } from "../_interface";

const PasswordEmail = (props: IconProps) => {
  return(
    <SvgIcon {...props} color="inherit" viewBox="0 0 40 40">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="20" fill="#F1F3F7"/>
      <path d="M27.1531 13.3972H12.847C11.9353 13.3972 11.1963 14.1362 11.1963 15.0479V24.9521C11.1963 25.8638 11.9353 26.6028 12.847 26.6028H27.1531C28.0648 26.6028 28.8038 25.8638 28.8038 24.9521V15.0479C28.8038 14.1362 28.0648 13.3972 27.1531 13.3972ZM27.1531 15.0479V16.4511C26.3821 17.0791 25.1528 18.0555 22.5247 20.1133C21.9456 20.5689 20.7983 21.6633 20.0001 21.6506C19.202 21.6635 18.0543 20.5687 17.4754 20.1133C14.8478 18.0558 13.6182 17.0792 12.847 16.4511V15.0479H27.1531ZM12.847 24.9521V18.5693C13.635 19.197 14.7525 20.0777 16.4558 21.4115C17.2074 22.0032 18.5238 23.3093 20.0001 23.3014C21.4691 23.3093 22.7688 22.0221 23.544 21.4118C25.2473 20.078 26.3651 19.197 27.1531 18.5693V24.9521H12.847Z" fill="#2E434D"/>
      </svg>
    </SvgIcon>
  );
}

export default PasswordEmail;